export default __webpack_public_path__ + "static/media/web3.fafe262c.png";